// src/Law.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Law_default = createIcon({
  displayName: "Law",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13.1427 2.99995C12.8829 3.00769 12.6363 3.11627 12.4552 3.30268L11.4552 4.30268L7.30284 8.45307C7.30116 8.45476 7.30061 8.45723 7.29894 8.45893L6.30284 9.45503C6.04161 9.70585 5.93638 10.0783 6.02774 10.4287C6.1191 10.7792 6.39277 11.0528 6.7432 11.1442C7.09364 11.2356 7.46609 11.1303 7.71691 10.8691L8.01183 10.5742L9.92589 12.4882L2.29308 20.121C2.03184 20.3719 1.92661 20.7443 2.01797 21.0947C2.10932 21.4452 2.38299 21.7189 2.73343 21.8102C3.08387 21.9016 3.45632 21.7963 3.70714 21.5351L11.34 13.9023L13.4259 15.9882L13.1329 16.2812C12.8717 16.532 12.7665 16.9045 12.8578 17.2549C12.9492 17.6053 13.2228 17.879 13.5733 17.9704C13.9237 18.0617 14.2962 17.9565 14.547 17.6953L15.545 16.6953L19.6974 12.5449L21.0353 11.207C21.331 10.9195 21.42 10.4799 21.2592 10.1001C21.0984 9.72022 20.721 9.47803 20.3087 9.49018C20.0489 9.49792 19.8023 9.6065 19.6212 9.79292L18.9903 10.4238L13.5763 5.00971L13.8693 4.71675C14.165 4.42925 14.2539 3.98968 14.0932 3.60983C13.9324 3.22999 13.555 2.98779 13.1427 2.99995ZM14.0157 20C13.6551 19.9949 13.3197 20.1843 13.1378 20.4958C12.956 20.8073 12.956 21.1926 13.1378 21.5041C13.3197 21.8156 13.6551 22.0051 14.0157 22H21.004C21.3647 22.0051 21.7001 21.8156 21.8819 21.5041C22.0637 21.1926 22.0637 20.8073 21.8819 20.4958C21.7001 20.1843 21.3647 19.9949 21.004 20H14.0157Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  Law_default
};
